import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { PrayerRequestProvider } from "./contexts/PrayerRequestContext";
import { App } from "./App";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { OrganizationProvider } from "./contexts/OrganizationContext";
import { Auth0ProviderWithNavigate } from "././auth0-provider-with-navigate";
import { ProfileProvider } from "./contexts/ProfileContext";
import { CallFormProvider } from "./contexts/CallFormContext";
import { FormFieldsProvider } from "./contexts/FormFieldsContext";
import { PrayerPartnerProvider } from "./contexts/PrayerPartnerContext";
import { PastoralProvider } from "./contexts/PastoralContext";
import { MailingProvider } from "./contexts/MailingContext";
import { ConfigurationProvider } from './contexts/ConfigurationContext';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <OrganizationProvider>
      <BrowserRouter>
        <Auth0ProviderWithNavigate>
          <ProfileProvider>
            <FormFieldsProvider>
            <CallFormProvider>
              <PrayerPartnerProvider>
                <PastoralProvider>
                  <MailingProvider>
                    <PrayerRequestProvider>
                      <ConfigurationProvider>
                        <App />
                      </ConfigurationProvider>
                    </PrayerRequestProvider>
                  </MailingProvider>
                </PastoralProvider>
              </PrayerPartnerProvider>
            </CallFormProvider>
            </FormFieldsProvider>
          </ProfileProvider>
        </Auth0ProviderWithNavigate>
      </BrowserRouter>
    </OrganizationProvider>
  </QueryClientProvider>
);
